export default "__VITE_ASSET__Cv$_j9$8__"